import {
  Authenticate,
  UserAuthority,
} from "../../../domain/authentication";
import { ConfiguredRequestConfig, HttpRepository } from "../..";
import { IAuthenticateBean, IUserAuthorityBean, IAuthenticateRequestBean, IExtraConfigurationBean } from "./beans";
import { UserRepository } from "../../user/ver2";
import { DepartmentRepository } from "../../department/ver2";
import { IAuthenticationRepository } from "..";
import { IConfiguration } from "../../../domain/configuration";
import { ObjectUtility } from "../../../utilities";

export class AuthenticationRepository extends HttpRepository implements IAuthenticationRepository {
  async getAuthentication(id: string, pass: string, hostName: string, departmentId: string, departmentGroupId: string, referenceableDepartmentGroupIds: string[], isDepartmentGroupScopeEnable: boolean): Promise<Authenticate> {
    const url = "/api/authpost";
    const request = this.createAuthenticateRequestBean(id, pass, departmentId, hostName, null, null, departmentGroupId, referenceableDepartmentGroupIds, isDepartmentGroupScopeEnable);
    const result = await this.post(url, request, ConfiguredRequestConfig.create());
    return AuthenticationRepository.toAuthenticate(result.data);
  }

  async getAuthenticationWithNoPassword(id: string, hostName: string, departmentId: string, orderUserId: string, attendingUserId: string, departmentGroupCode: string, referenceableDepartmentGroupIds: string[], isDepartmentGroupScopeEnable: boolean): Promise<Authenticate> {
    const url = "/api/authpost/nopassword";
    const request = this.createAuthenticateRequestBean(id, null, departmentId, hostName, orderUserId, attendingUserId, departmentGroupCode, referenceableDepartmentGroupIds, isDepartmentGroupScopeEnable);
    const result = await this.post(url, request, ConfiguredRequestConfig.create());
    return AuthenticationRepository.toAuthenticate(result.data);
  }

  private createAuthenticateRequestBean(userId: string, password: string, departmentId: string, hostName: string, orderUserId: string, attendingUserId: string, departmentGroupCode: string, referenceableDepartmentGroupIds: string[], isDepartmentGroupScopeEnable: boolean): IAuthenticateRequestBean {
    return {
      userId: userId,
      password: password,
      departmentId: departmentId,
      hostName: hostName,
      orderUserId: orderUserId,
      attendingUserId: attendingUserId,
      departmentGroupId: departmentGroupCode,
      referenceableDepartmentGroupIds: referenceableDepartmentGroupIds,
      enableDepartmentGroupScope: isDepartmentGroupScopeEnable,
    };
  }

  private static toAuthenticate(auth: IAuthenticateBean): Authenticate {
    return new Authenticate(
      auth.token,
      UserRepository.toUser(auth.user),
      DepartmentRepository.toDepartment(auth.loginDepartment),
      DepartmentRepository.toDepartment(auth.mainDepartment),
      DepartmentRepository.toDepartment(auth.previousSelectedDepartment),
      DepartmentRepository.toDepartments(auth.departments),
      AuthenticationRepository.toUserAuthority(auth.userAuthority),
      UserRepository.toUser(auth.orderUser),
      UserRepository.toUser(auth.attendingUser),
      this.toExtraConfiguration(auth.extraConfiguration),
      DepartmentRepository.toDepartmentGroup(auth.loginDepartmentGroup),
      DepartmentRepository.toDepartmentGroups(auth.referenceableDepartmentGroups),
    );
  }

  private static toExtraConfiguration(bean: IExtraConfigurationBean): IConfiguration {
    if (!bean || (!bean.user && !bean.profession)) { return null; }
    // 検証しきれないので、DefaultConfigurationはマージしない
    const baseObject = {} as any;
    const professionMerged = ObjectUtility.mergeDeeply(baseObject, bean.profession);
    return ObjectUtility.mergeDeeply(professionMerged, bean.user);
  }

  private static toUserAuthority(bean: IUserAuthorityBean): UserAuthority {
    return new UserAuthority(
      bean.documentEditable,
      bean.documentDeletable,
      bean.documentPrintable,
      bean.formatEditable,
      bean.hierarchiesEditable,
      bean.administratorDepartmentIds,
      bean.isOrderable,
      bean.commonItemEditable,
      bean.maintenanceAccessible,
    );
  }

  async discardAuthentication(id: string, token: string): Promise<void> {
    const url = "/api/auth/logout/" + id;
    const query = {
      params: {
        token,
      }
    };
    await this.get(url, query);
  }
}
